import * as singleSpa from "single-spa"
import { coreActions } from "../slices/core.slice"

export const redirectToLogin = () => {
  console.trace()
  const url = (window.location.pathname + window.location.hash).slice(1)
  window.location.href = `/platform/login?page=${url}`
}

export const findTenantId = (tenants: any[], key: string) =>
  tenants?.find((a) => a.hint.toLowerCase() === key)?.id

export const hideShellLoader = () => {
  const loader = document.querySelector(".skeleton-loader")
  loader?.remove()
}

export const navigateTo401 = (store) => {
  singleSpa.navigateToUrl("/401")
  store.dispatch(coreActions.setLoaderStatus(false))
  hideShellLoader()
}
